import { makeAutoObservable } from 'sdk';

export type Dimensions = { width: number; height: number };

export class ClientViewportStore {
	constructor() {
		makeAutoObservable(this);

		const f = (): void => {
			this.updateDimensions(window.innerHeight, window.innerWidth);
		};

		window.addEventListener('load', f);
		window.addEventListener('resize', f);
		window.addEventListener('orientationchange', f);

		window.addEventListener('beforeunload', () => {
			window.removeEventListener('load', f);
			window.removeEventListener('resize', f);
			window.removeEventListener('orientationchange', f);
		});
	}

	height = 0;
	width = 0;

	private updateDimensions(h: number, w: number): void {
		this.setHeight(h);
		this.setWidth(w);
	}

	private setWidth(w: number): void {
		this.width = w;
	}

	private setHeight(h: number): void {
		this.height = h;
	}
}
